import { render, staticRenderFns } from "./InventoryForecastSettings.vue?vue&type=template&id=6454b3ae&scoped=true"
import script from "./InventoryForecastSettings.vue?vue&type=script&lang=ts"
export * from "./InventoryForecastSettings.vue?vue&type=script&lang=ts"
import style0 from "./InventoryForecastSettings.vue?vue&type=style&index=0&id=6454b3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454b3ae",
  null
  
)

export default component.exports